import { FormItem } from '../../../../../../commons/Form/Form.types';
import { CommerciauxFiltersFormSchema } from './CommerciauxFiltersForm.types';

export const commerciauxFiltersFormData: FormItem<CommerciauxFiltersFormSchema>[][] = [
  [
    {
      name: 'enabled',
      placeholder: 'Sélectionnez une proposition...',
      label: 'Seulement commerciaux actifs',
      type: 'select',
      id: 'active',
      // @ts-ignore
      defaultValue: [{ value: 'both', label: 'Les deux' }],
      options: [
        {
          value: 'both',
          label: 'Les deux',
        },
        {
          value: 'true',
          label: 'Oui',
        },
        {
          value: 'false',
          label: 'Non',
        },
      ],
    },
  ],
  // [
  //   {
  //     name: 'region',
  //     placeholder: "Filtrer par région...",
  //     label: "Région",
  //     type: 'select',
  //     id: 'region'
  //   }
  // ],
  [
    {
      name: 'department',
      placeholder: 'Filtrer par département...',
      label: 'Département',
      type: 'select',
      id: 'department',
    },
  ],
];
